import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=077bf13c&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077bf13c",
  null
  
)

export default component.exports